import { apiClient } from '../services/api-client';

/**
 * POSTs a notification request to a care-hooks `/hooks/{mail,text,web-survey}`
 * endpoint.
 *
 * `TResponse` defaults to `unknown` because no consumer reads the reply: every call
 * site branches on promise settlement only. Nothing in this codebase establishes what
 * the body contains; a caller that knows can supply it.
 */
const SendGridPoster = async <TResponse = unknown>(
  endPoint: string,
  token: string,
  data: unknown,
): Promise<TResponse> => {
  const result = await apiClient.post<TResponse>(
    import.meta.env.VITE_CARE_HOOKS_API_NAME,
    endPoint,
    {
      headers: {
        Authorization: 'Bearer ' + token,
        'Content-Type': 'application/json',
      },
      body: data,
    },
  );
  return result;
};

export default SendGridPoster;
